import { useNavigate } from "react-router-dom";
import { Typography } from "antd";
import { IBlog } from "../../../helpers/types";
import "./index.less";

const BlogCard = ({ blog }: { blog: IBlog, key: string }) => {
  const navigate = useNavigate();

  const handleClickBlog = () => {
    navigate(`/blogs/${blog._id}`);
  }
  return (
    <div
      key={blog._id}
      onClick={handleClickBlog}
      className="blog-card"
      style={{
        backgroundImage: `url(${blog.fileId?.url})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}>

      <div className="blog-text-holder">
        <Typography.Text className="blog-title">{blog.title}</Typography.Text>
        <Typography.Text className="blog-description">{blog.description}</Typography.Text>
      </div>
    </div>
  )
}

export default BlogCard
